import React from 'react';
import styles from './LoginLayout.module.css';
import Box from '@mui/material/Box';

interface LoginLayoutProps {
  children: React.ReactNode;
}

const LoginLayout: React.FC<LoginLayoutProps> = ({ children }) => {
  return (
    <Box className={styles.loginLayout}>
      <Box className={styles.loginContent}>
        {children}
      </Box>
    </Box>
  );
};

export default LoginLayout;
